<template>
	<app-page>
		<div class="main-title">
			关于完善研究开发费用税前加计扣除政策的通知
		</div>
		<div class="flex flex-end clearfix">
			<el-button type="primary" @click="goback()">返回</el-button>
		</div>
		<div class="detail-content">
			<div data-v-bbdef3ee="" class="detail-content">
				<p style="text-align:center;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#999999">财税〔2015〕119号</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"
									>各省、自治区、直辖市、计划单列市财政厅（局）、国家税务局、地方税务局、科技厅（局），新疆生产建设兵团财务局、科技局：</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									根据《中华人民共和国企业所得税法》及其实施条例有关规定，为进一步贯彻落实《中共中央
									国务院关于深化体制机制改革加快实施创新驱动发展战略的若干意见》精神，更好地鼓励企业开展研究开发活动（以下简称研发活动）和规范企业研究开发费用（以下简称研发费用）加计扣除优惠政策执行，现就企业研发费用税前加计扣除有关问题通知如下：</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									一、研发活动及研发费用归集范围</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									本通知所称研发活动，是指企业为获得科学与技术新知识，创造性运用科学技术新知识，或实质性改进技术、产品（服务）、工艺而持续进行的具有明确目标的系统性活动。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（一）允许加计扣除的研发费用。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业开展研发活动中实际发生的研发费用，未形成无形资产计入当期损益的，在按规定据实扣除的基础上，按照本年度实际发生额的50%，从本年度应纳税所得额中扣除；形成无形资产的，按照无形资产成本的150%在税前摊销。研发费用的具体范围包括：</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 1.人员人工费用。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									直接从事研发活动人员的工资薪金、基本养老保险费、基本医疗保险费、失业保险费、工伤保险费、生育保险费和住房公积金，以及外聘研发人员的劳务费用。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 2.直接投入费用。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（1）研发活动直接消耗的材料、燃料和动力费用。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（2）用于中间试验和产品试制的模具、工艺装备开发及制造费，不构成固定资产的样品、样机及一般测试手段购置费，试制产品的检验费。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（3）用于研发活动的仪器、设备的运行维护、调整、检验、维修等费用，以及通过经营租赁方式租入的用于研发活动的仪器、设备租赁费。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 3.折旧费用。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									用于研发活动的仪器、设备的折旧费。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 4.无形资产摊销。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									用于研发活动的软件、专利权、非专利技术（包括许可证、专有技术、设计和计算方法等）的摊销费用。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									5.新产品设计费、新工艺规程制定费、新药研制的临床试验费、勘探开发技术的现场试验费。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 6.其他相关费用。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									与研发活动直接相关的其他费用，如技术图书资料费、资料翻译费、专家咨询费、高新科技研发保险费，研发成果的检索、分析、评议、论证、鉴定、评审、评估、验收费用，知识产权的申请费、注册费、代理费，差旅费、会议费等。此项费用总额不得超过可加计扣除研发费用总额的10%。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									7.财政部和国家税务总局规定的其他费用。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									（二）下列活动不适用税前加计扣除政策。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									1.企业产品（服务）的常规性升级。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									2.对某项科研成果的直接应用，如直接采用公开的新工艺、材料、装置、产品、服务或知识等。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									3.企业在商品化后为顾客提供的技术支持活动。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									4.对现存产品、服务、技术、材料或工艺流程进行的重复或简单改变。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									5.市场调查研究、效率调查或管理研究。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									6.作为工业（服务）流程环节或常规的质量控制、测试分析、维修维护。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									7.社会科学、艺术或人文学方面的研究。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 二、特别事项的处理</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									1.企业委托外部机构或个人进行研发活动所发生的费用，按照费用实际发生额的80%计入委托方研发费用并计算加计扣除，受托方不得再进行加计扣除。委托外部研究开发费用实际发生额应按照独立交易原则确定。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									委托方与受托方存在关联关系的，受托方应向委托方提供研发项目费用支出明细情况。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									企业委托境外机构或个人进行研发活动所发生的费用，不得加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									2.企业共同合作开发的项目，由合作各方就自身实际承担的研发费用分别计算加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									3.企业集团根据生产经营和科技开发的实际情况，对技术要求高、投资数额大，需要集中研发的项目，其实际发生的研发费用，可以按照权利和义务相一致、费用支出和收益分享相配比的原则，合理确定研发费用的分摊方法，在受益成员企业间进行分摊，由相关成员企业分别计算加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									4.企业为获得创新性、创意性、突破性的产品进行创意设计活动而发生的相关费用，可按照本通知规定进行税前加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									创意设计活动是指多媒体软件、动漫游戏软件开发，数字动漫、游戏设计制作；房屋建筑工程设计（绿色建筑评价标准为三星）、风景园林工程专项设计；工业设计、多媒体设计、动漫及衍生产品设计、模型设计等。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 三、会计核算与管理</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									1.企业应按照国家财务会计制度要求，对研发支出进行会计处理；同时，对享受加计扣除的研发费用按研发项目设置辅助账，准确归集核算当年可加计扣除的各项研发费用实际发生额。企业在一个纳税年度内进行多项研发活动的，应按照不同研发项目分别归集可加计扣除的研发费用。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									2.企业应对研发费用和生产经营费用分别核算，准确、合理归集各项费用支出，对划分不清的，不得实行加计扣除。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									四、不适用税前加计扣除政策的行业</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 1.烟草制造业。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 2.住宿和餐饮业。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 3.批发和零售业。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 4.房地产业。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 5.租赁和商务服务业。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 6.娱乐业。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									7.财政部和国家税务总局规定的其他行业。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									上述行业以《国民经济行业分类与代码（GB/4754-2011）》为准，并随之更新。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									五、管理事项及征管要求</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									1.本通知适用于会计核算健全、实行查账征收并能够准确归集研发费用的居民企业。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									2.企业研发费用各项目的实际发生额归集不准确、汇总额计算不准确的，税务机关有权对其税前扣除额或加计扣除额进行合理调整。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									3.税务机关对企业享受加计扣除优惠的研发项目有异议的，可以转请地市级（含）以上科技行政主管部门出具鉴定意见，科技部门应及时回复意见。企业承担省部级（含）以上科研项目的，以及以前年度已鉴定的跨年度研发项目，不再需要鉴定。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									4.企业符合本通知规定的研发费用加计扣除条件而在2016年1月1日以后未及时享受该项税收优惠的，可以追溯享受并履行备案手续，追溯期限最长为3年。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									5.税务部门应加强研发费用加计扣除优惠政策的后续管理，定期开展核查，年度核查面不得低于20%。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 六、执行时间</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									本通知自2016年1月1日起执行。《国家税务总局关于印发〈企业研究开发费用税前扣除管理办法（试行）〉的通知》（国税发〔2008〕116号）和《财政部
									国家税务总局关于研究开发费用税前加计扣除有关政策问题的通知》（财税〔2013〕70号）同时废止。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									财政部 国家税务总局 科技部</span
								></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;"></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 2015年11月2日</span></span
							></span
						></span
					>
				</p>
			</div>
		</div>
	</app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";

export default {
	components: {
		AppPage
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>